module.exports = __webpack_public_path__ + "static/media/Charles C. Pinckney - 1804.7e18634e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Charles C. Pinckney - 1804.jpg
// module id = 448
// module chunks = 0